module.exports = __webpack_public_path__ + "static/media/s_baseball.6ea629f1.mp3";